import axios from "axios";
import { API_PATHS } from "@config/constants";

export const getBidProductApi = async () => {
  const { data, status } = await axios.get(API_PATHS.bidProduct);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get product!");
  }

  return data.data;
};

export const bidHistoryApi = async ({ queryKey }) => {
  const [, { page, sort, cp_ids, pageSize }] = queryKey;
  const { data, status } = await axios.get(`${API_PATHS.bidHistory}?pageSize=${pageSize}&current=${page}&sort=${sort}&cp_ids=${cp_ids?.join(",") || ""}`);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get history bid");
  }

  return data;
};

export const bidHistoryAllApi = async ({ queryKey }) => {
  const [, { page, sort, pageSize }] = queryKey;
  const { data, status } = await axios.get(
    `${API_PATHS.bidHistoryAll}?pageSize=${pageSize}&current=${page}&sort=${sort}`
  );
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get history bid");
  }

  return data;
};

export const getUpNextProductApi = async () => {
  const { data, status } = await axios.get(API_PATHS.upNextProduct);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get products!");
  }

  return data.data;
};


export const getFinishedProductApi = async () => {
  const { data, status } = await axios.get(API_PATHS.finishedProduct);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get products!");
  }

  return data.data;
};

export const getFinishedDetailProductApi = async ({ queryKey }) => {
  const [, { cp_id }] = queryKey;
  const { data, status } = await axios.get(`${API_PATHS.finishedProduct}/${cp_id}`);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get product!");
  }

  return data.data;
};

export const getResultsProductApi = async () => {
  const { data, status } = await axios.get(API_PATHS.resultsProduct);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get products!");
  }

  return data.data;
};

export const getResultDetailProductApi = async ({ queryKey }) => {
  const [, { cp_id }] = queryKey;
  const { data, status } = await axios.get(`${API_PATHS.resultsProduct}/${cp_id}`);
  if (status !== 200) {
    throw new Error(data.errorMessage || "Can't get product!");
  }

  return data.data;
};

export const getPotentialWinnerApi = async ({ queryKey }) => {
  const [, cp_id] = queryKey;
  const { data, status } = await axios.get(`${API_PATHS.viewPotentialWinner}/${cp_id}`);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't view potential winner");
  }
  return data.data;
};

export const checkStatusEventNewYearAPI = async () => {
  const { data, status } = await axios.get(API_PATHS.eventCheckStatus);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't check status event new year 2024");
  }
  return data.data;
};

export const getStatisticEventNewYearApi = async () => {
  const { data, status } = await axios.get(API_PATHS.eventGetStatistic);
  if (status !== 200 || data?.success === false) {
    throw new Error(
      data.errorMessage || "Can't get statistic event new year 2024"
    );
  }
  return data.data;
};

export const getHistoryEventNoelApi = async ({ queryKey }) => {
  const [, { limit, page }] = queryKey;
  const { data, status } = await axios.get(`${API_PATHS.eventNoelHistory}?limit=${limit}&page=${page}`);
  if (status !== 200 || data?.success === false) {
    throw new Error(
      data.errorMessage || "Can't get statistic event new year 2024"
    );
  }
  return data.data;
}

export const postPairingEventNewYearApi = async () => {
  const { data, status } = await axios.post(API_PATHS.eventPairing);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't pairing!");
  }

  return data;
};

export const postStartOpenEventNoel = async (isSuper = 0) => {
  const { data, status } = await axios.post(API_PATHS.eventNoelStartOpen, isSuper);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't pairing!");
  }

  return data;
};
